export * from './account.service';
import { AccountService } from './account.service';
export * from './authApi.service';
import { AuthApiService } from './authApi.service';
export * from './authMethods.service';
import { AuthMethodsService } from './authMethods.service';
export * from './authenticationMethodConfiguration.service';
import { AuthenticationMethodConfigurationService } from './authenticationMethodConfiguration.service';
export * from './authenticationType.service';
import { AuthenticationTypeService } from './authenticationType.service';
export * from './certificate.service';
import { CertificateService } from './certificate.service';
export * from './credentialReset.service';
import { CredentialResetService } from './credentialReset.service';
export * from './credentialResetProxy.service';
import { CredentialResetProxyService } from './credentialResetProxy.service';
export * from './error.service';
import { ErrorService } from './error.service';
export * from './fido.service';
import { FidoService } from './fido.service';
export * from './hardwareToken.service';
import { HardwareTokenService } from './hardwareToken.service';
export * from './legacySecurEnvoyApp.service';
import { LegacySecurEnvoyAppService } from './legacySecurEnvoyApp.service';
export * from './loginHistory.service';
import { LoginHistoryService } from './loginHistory.service';
export * from './notificationTest.service';
import { NotificationTestService } from './notificationTest.service';
export * from './oIDCClient.service';
import { OIDCClientService } from './oIDCClient.service';
export * from './questionSecretAnswer.service';
import { QuestionSecretAnswerService } from './questionSecretAnswer.service';
export * from './redirect.service';
import { RedirectService } from './redirect.service';
export * from './settings.service';
import { SettingsService } from './settings.service';
export * from './tenantCleanup.service';
import { TenantCleanupService } from './tenantCleanup.service';
export * from './userAuthCredential.service';
import { UserAuthCredentialService } from './userAuthCredential.service';
export * from './userCredential.service';
import { UserCredentialService } from './userCredential.service';
export * from './userSession.service';
import { UserSessionService } from './userSession.service';
export * from './userToken.service';
import { UserTokenService } from './userToken.service';
export * from './version.service';
import { VersionService } from './version.service';
export const APIS = [AccountService, AuthApiService, AuthMethodsService, AuthenticationMethodConfigurationService, AuthenticationTypeService, CertificateService, CredentialResetService, CredentialResetProxyService, ErrorService, FidoService, HardwareTokenService, LegacySecurEnvoyAppService, LoginHistoryService, NotificationTestService, OIDCClientService, QuestionSecretAnswerService, RedirectService, SettingsService, TenantCleanupService, UserAuthCredentialService, UserCredentialService, UserSessionService, UserTokenService, VersionService];
